import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FilterMenu } from '../../../shared/models/filter-menu';
import { SortMenu } from '../../../shared/models/sort-menu';
import { PanelList } from '../../../shared/models/panel-list';
import { sessionAttendeeDTO } from '../../models/sessionAttendeeDTO';
import { SessionAttendeeParticipationConstants } from '../../constants/sessionAttendeeParticipation.constants';
import { SessionAttendeePassOrFailConstants } from '../../constants/sessionAttendeePassOrFail.constants';
import { CourseConstants } from '../../constants/course.constants';
import { CommonService } from '../../../shared/services/common.service';
@Component({
  selector: 'app-session-attendee-panelist',
  templateUrl: './session-attendee-panelist.component.html',
  styleUrls: ['./session-attendee-panelist.component.scss']
})
export class SessionAttendeePanelistComponent {
  isShowCheckbox: boolean = true;

  @Input() SliderHeader: string = "";
  @Input() sessionAttendeesData: sessionAttendeeDTO[] = [];
  @Input() minimumPassingScore: string | null = null;
  @Input() ScoringOption: string | null = null;
  @Input() ProficiencyQuiz: string | null = null;
  @Input() courseNumber !: string;
  @Output() selectedItems = new EventEmitter();
  @Output() checkboxSelection = new EventEmitter();
  @Output() gradeChangeEvent = new EventEmitter();
  checkboxLabel: string = CourseConstants.Session_Attendee_ShowAllInformation;
  showInformationIconCheckbox: boolean = true;
  informationIconTooltip: string = CourseConstants.Session_Attendee_InformationToolTip;
  selectCheckbox = false;
  quizResponse : any;
  quizData : any;
  quizReadOnly : boolean = false;
  noData : boolean = false;

  sessionAttendeePanelListData: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableSelection: true,
    enableToggling: false,
  };

  constructor(private commonService: CommonService
    ) {

  }

  ngOnInit(){
    this.setPanelList();
  }

  ngOnChanges() {
    this.setPanelList();
  }

  setPanelList(){
    this.sessionAttendeePanelListData.lists = this.sessionAttendeesData;
    this.noData = this.commonService.IsListEmpty(this.sessionAttendeesData);
    this.bindPanelListData();
  }

  bindPanelListData(){
    this.addSorting();
    this.addFilters();
    this.sessionAttendeePanelListData ={...this.sessionAttendeePanelListData};
  }

  getSelectedItems(selectedItemsData: sessionAttendeeDTO[]) {
    this.selectedItems.emit(selectedItemsData);
  }

  getGradeDispaly(participation: string) : boolean{
    if(participation == SessionAttendeeParticipationConstants.ParticipationName_Absent 
      || participation == SessionAttendeeParticipationConstants.ParticipationName_Waitlist
      || participation == SessionAttendeeParticipationConstants.ParticipationName_Withdrawn)
        return true;
    return false;
  }

  gradeDisplay(){
    return !(this.ScoringOption == CourseConstants.Session_Attendee_ScoringOption_PassFail && this.ProficiencyQuiz == CourseConstants.Session_Attendee_ProficiencyQuiz_None);
  }

  checkboxSelectionChange(){
    this.checkboxSelection.emit(this.selectCheckbox);
  }

  addFilters(){
    this.sessionAttendeePanelListData.enableFilter = true;
    this.sessionAttendeePanelListData.filters = this.getFiltersForSessionAttendeePanelList();
  }

  addSorting(){
    this.sessionAttendeePanelListData.enableSort = true;
    this.sessionAttendeePanelListData.sort = this.getSortFieldsForSessionAttendeePanelList();
  }

  gradeDataChange(gradeUpdate: any){
    this.gradeChangeEvent.emit(true);
  }

  getFiltersForSessionAttendeePanelList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'Attendee',
        filterFieldName: 'attendee',
      },
      {
        filterDisplayName: 'Participation',
        filterFieldName: 'participation',
      },
      {
        filterDisplayName: 'Pass/Fail',
        filterFieldName: 'passOrFail',
      }
    );
    return filters;
  }

  getSortFieldsForSessionAttendeePanelList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'Attendee',
        sortFieldName: 'attendee',
      },
      {
        sortFieldDisplayName: 'Participation',
        sortFieldName: 'participation',
      },
      {
        sortFieldDisplayName: 'Pass/Fail',
        sortFieldName: 'passOrFail',
      });
      return sortMenu;
    }


    clearSelection(){
      this.sessionAttendeePanelListData.clearSelection = true;
        this.sessionAttendeePanelListData = { ...this.sessionAttendeePanelListData };
    }

    calculateParticipationColor(participation: string) : string{
      let participationColor = '';
      switch(participation){
        case SessionAttendeeParticipationConstants.ParticipationName_Enrolled:
          participationColor = SessionAttendeeParticipationConstants.ParticipationClassName_Enrolled;
          break;
        case SessionAttendeeParticipationConstants.ParticipationName_Attended:
          participationColor = SessionAttendeeParticipationConstants.ParticipationClassName_Attended;
          break;
        case SessionAttendeeParticipationConstants.ParticipationName_Absent:
          participationColor = SessionAttendeeParticipationConstants.ParticipationClassName_Absent;
          break;
        case SessionAttendeeParticipationConstants.ParticipationName_Waitlist:
          participationColor = SessionAttendeeParticipationConstants.ParticipationClassName_Waitlist;
          break;
        case SessionAttendeeParticipationConstants.ParticipationName_Withdrawn:
          participationColor = SessionAttendeeParticipationConstants.ParticipationClassName_Withdrawn;
          break;
      }
      return participationColor;
    }

    calculatePassOrFailColor(status: string) : string {
      let statusColor = '';
      switch(status){
        case SessionAttendeePassOrFailConstants.AttendeeStatus_Fail:
          statusColor = SessionAttendeePassOrFailConstants.AttendeeClassName_Fail;
          break;
        case SessionAttendeePassOrFailConstants.AttendeeStatus_Pass:
          statusColor = SessionAttendeePassOrFailConstants.AttendeeClassName_Pass;
          break;
        default:
          break;
      }
      return statusColor;
    }

    openQuiz(attendee: string, isQuizAnswerButtonVisible: boolean, sessionId:string){
      if(isQuizAnswerButtonVisible){
        var startIndex = attendee.indexOf('(');
        var endIndex = attendee.indexOf(')');
        var puid = attendee.substring(startIndex+1,endIndex);
        setTimeout(() => {
        window.open(`/training/eqms.quizAnswers/${puid}?courseNumber=${this.courseNumber}&&attendee=${attendee}&&sessionId=${sessionId}`, '_blank');
      }, 1000);
    }
    }

    changeIconColor(isQuizAnswerButtonVisible: boolean): string{
      if(isQuizAnswerButtonVisible){
        return 'enable';
      }
      else{
        return 'disable'
      }
    }
}
